module.exports = __webpack_public_path__ + "img/KinokoTable25.f3ba6ac4.jpg";